import { parsePhoneNumberWithError } from 'libphonenumber-js'

/* tslint:disable */
export const formartPhoneNoWithCountryCodeStr: any = (
  phoneNo: string
): string => {
  if (!phoneNo) {
    return 'N/A'
  }
  const block4: string = phoneNo?.substring(
    phoneNo?.length - 4,
    phoneNo?.length
  )
  const block3: string = phoneNo?.substring(
    phoneNo?.length - 7,
    phoneNo?.length - 4
  )
  const block2: string = phoneNo?.substring(
    phoneNo?.length - 9,
    phoneNo?.length - 7
  )
  const block1: string = phoneNo?.substring(0, phoneNo?.length - 9)

  return `${block1} ${block2} ${block3} ${block4}`.trim().replace(/\s\s+/g, ' ')
}

export const formatMobileNoInternational = (mobileNo: string = ''): string => {
  if (!mobileNo) {
    return 'N/A'
  }

  if (!mobileNo?.startsWith('+')) {
    return mobileNo
  }

  try {
    return parsePhoneNumberWithError(mobileNo).formatInternational()
  } catch (error) {
    return mobileNo
  }
}

export const formartPhoneNoWithoutCountryCodeStr: any = (
  phoneNo: string
): string => {
  if (!phoneNo) {
    return 'N/A'
  }
  if (phoneNo?.substring(0, 3) === '+84') {
    const block3: string = phoneNo?.substring(
      phoneNo?.length - 4,
      phoneNo?.length
    )
    const block2: string = phoneNo?.substring(
      phoneNo?.length - 7,
      phoneNo?.length - 4
    )
    const block1: string = phoneNo?.substring(
      phoneNo?.length - 9,
      phoneNo?.length - 7
    )
    const block0: string = phoneNo?.substring(
      phoneNo?.length - 11,
      phoneNo?.length - 9
    )

    return `${block0} ${block1} ${block2} ${block3} `
      .trim()
      .replace(/\s\s+/g, ' ')
  } else {
    const block3: string = phoneNo?.substring(
      phoneNo?.length - 4,
      phoneNo?.length
    )
    const block2: string = phoneNo?.substring(
      phoneNo?.length - 7,
      phoneNo?.length - 4
    )
    const block1: string = phoneNo?.substring(
      phoneNo?.length - 9,
      phoneNo?.length - 7
    )
    const block0: string = phoneNo?.substring(
      phoneNo?.length - 12,
      phoneNo?.length - 9
    )

    return `${block0} ${block1} ${block2} ${block3} `
      .trim()
      .replace(/\s\s+/g, ' ')
  }
}

export const formartNationalIdWithoutCountryCodeStr: any = (
  nationalId: string
): string => {
  return nationalId?.substring(4, nationalId?.length)?.trim()
}

export const formatPhoneSpokeAccount: any = (phoneNo: string = ''): string => {
  const block1: string = phoneNo.substring(0, 3)
  const block2: string = phoneNo.substring(3, 6)
  const block3: string = phoneNo.substring(6)

  return `${block1} ${block2} ${block3}`.trim().replace(/\s\s+/g, ' ')
}

export const compactFileUrl: any = (
  url: string,
  length: number = 32
): string => {
  if (typeof url !== 'string') {
    return ''
  }

  const minLength: number = 10

  if (url.length <= length || url.length <= minLength) {
    return url
  }

  const first: string = url.slice(0, 10)
  const last: string = url.slice(-(length - 13))

  return `${first}...${last}`
}

export const capitalizeFirstLetter: any = (string: string = ''): string => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

export const toCamelCase = (str: string = ''): string => {
  return str
    .toLowerCase()
    .split(/[^a-zA-Z0-9]+/)
    .map((word, idx) =>
      idx === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join('')
}

export const formatAddress: any = (string: string = ''): string => {
  const array: string[] = string.split('_')
  for (let i: number = 0; i < array.length; i++) {
    array[i] =
      array[i].charAt(0).toUpperCase() + array[i].slice(1).toLowerCase()
  }
  const strFormat: string = array.join(' ')
  return strFormat
}

export const formatNumberWithComma: any = (number: number): string => {
  const options: {
    minimumFractionDigits: number
    maximumFractionDigits: number
  } = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
  return Number(number).toLocaleString('en', options)
}

// No backtracking risk, simple split check
export const checkFormatEmailComponent = (email: string): boolean => {
  if (!email.includes('@')) return false
  const atCount = (email.match(/@/g) || []).length
  if (atCount !== 1) return false
  const [username, domain] = email.split('@')
  if (!username || !domain) return false
  if (!/^[a-zA-Z0-9._-]+$/.test(username)) return false
  if (!/^[a-zA-Z0-9-.]+$/.test(domain)) return false
  if (
    ['-', '.'].includes(domain[0]) ||
    ['-', '.'].includes(domain[domain.length - 1])
  )
    return false
  // Optional: check that domain contains at least one dot (.)
  if (!domain.includes('.')) return false
  return true
}

export const createOptionalEmailFormatValidator =
  (
    invalidFields: string[],
    setInvalidFields: (fields: string[]) => void
  ): ((rule: any, value: string) => Promise<void>) =>
  (rule: any, value: string): Promise<void> => {
    const withoutThisField: string[] = invalidFields.filter(
      (field: string): boolean => rule.field !== field
    )

    if (!value) {
      setInvalidFields(withoutThisField)
      return Promise.resolve()
    }

    if (!checkFormatEmailComponent(value)) {
      setInvalidFields([...invalidFields, rule.field])
      return Promise.reject(new Error('Invalid email format'))
    }

    setInvalidFields(withoutThisField)
    return Promise.resolve()
  }

export const formartRequestIdCoporatePricingManagement: any = (
  requestId: string
): string => {
  const id: string = requestId?.substring(
    requestId?.length - 10,
    requestId?.length
  )

  return id.trim().replace(/\s\s+/g, ' ')
}

export const getTokenIDJWT: any = (str: string): any => {
  const splitFirstTime: string | undefined = str
    .split('#')
    .find((item: string): any => {
      return item.includes('id_token') || ''
    })

  const splitSecondTime: string | undefined = splitFirstTime
    ?.split('&')
    .find((item: string): any => {
      return item.includes('id_token') || ''
    })

  const splitThirdTime: string | undefined = splitSecondTime
    ?.split('=')
    .find((item: string): any => {
      return !item.includes('id_token') || ''
    })

  return splitThirdTime
}

export const getPathFromAzure: any = (str: string): any => {
  const splitFirstTime: string | undefined = str
    .split('#')
    .find((item: string): any => {
      return item.includes('state') || ''
    })

  const splitSecondTime: string | undefined = splitFirstTime
    ?.split('&')
    .find((item: string): any => {
      return item.includes('state') || ''
    })

  const splitThirdTime: string | undefined = splitSecondTime
    ?.split('=')
    .find((item: string): any => {
      return !item.includes('state') || ''
    })

  return splitThirdTime
}

export const checkAccountIsDeactive: any = (link: string): any => {
  return link.includes('User+is+disabled')
}

export const addSpacesBeforeUpperCase: any = (input: string): string => {
  return input.replace(/([A-Z])/g, ' $1').trim()
}

export const checkValidPercentage: any = (val: string): boolean => {
  if (val === '' || !val) {
    return true
  }
  const percentValue: number = parseInt(val, 10)
  return percentValue >= 0 && percentValue <= 100
}

export const formatRole: (role: string) => string = (role: string): string => {
  if (!role) {
    return ''
  }

  return role
    .split('_')
    .map(
      (word: string): string =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(' ')
}
